import { combineReducers } from "@reduxjs/toolkit";
import appMetaReducers from "@/store/slices/appMeta";
import authReducers from "@/store/slices/auth";
import contentsReducers from "@/store/slices/contents";
import changePasswordReducers from "@/store/slices/changePassword";
import forgotPasswordReducers from "@/store/slices/forgotPassword";
import organizationPlanItemsReducers from "@/store/slices/organizationPlanItems";
import organizationPlanBucketsReducers from "@/store/slices/organizationPlanBuckets";
import organizationResponsesReducers from "@/store/slices/organizationResponses";
import organizationSetsReducers from "@/store/slices/organizationSets";
import organizationTeamReducers from "@/store/slices/organizationTeam";
import programsReducers from "@/store/slices/programs";

export default combineReducers({
  app_meta: appMetaReducers,
  auth: authReducers,
  contents: contentsReducers,
  change_password: changePasswordReducers,
  forgot_password: forgotPasswordReducers,
  organization_plan_items: organizationPlanItemsReducers,
  organization_plan_buckets: organizationPlanBucketsReducers,
  organization_responses: organizationResponsesReducers,
  organization_sets: organizationSetsReducers,
  organization_team: organizationTeamReducers,
  programs: programsReducers,
});
